import React, {
  useEffect,
  useState,
  useRef,
  useMemo,
  useCallback,
} from "react";
import Header from "../../components/Header";
import { connect } from "react-redux";
import Layout from "../../Layout";
import DatePicker from "react-datepicker";
import { DateTime, Interval } from "luxon";
import { getGameList } from "selectors/game";
import { listGames, listLeaderboard } from "../../actions/game";
import GameList from "components/Game/GameList";
import Paging from "../../components/Paging";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";

import router from "router";
import { getLeaderboard } from "actions/user";

const SessionsListPage = ({
  listGames,
  listLeaderboard,
  gameList,
  leaderboardList,
}) => {
  const { isFetching, isFetched, listData, count } = gameList;
  const [pageParams, setPageParams] = useState({ limit: 20, skip: 0 });
  const { t } = useTranslation();
  useEffect(() => {
    listGames({ ...pageParams });
  }, [pageParams]);

  return (
    <Layout>
      <Header></Header>
      <div className="container mx-auto">
        <h2 className="text-center text-2xl uppercase leading-tight mt-10 mb-10">
          {t("sessions")}
        </h2>
        <div className="mt-8 flex flex-row items-start justify-start">
          <Paging total={count} setPageParams={setPageParams}></Paging>
        </div>
        {gameList.isFetched && <GameList games={gameList.listData.games} />}
      </div>
    </Layout>
  );
};

const mapStateToProps = (state) => ({
  gameList: getGameList(state),
  leaderboardList: getLeaderboard(state),
});

const mapDispatchToProps = {
  listGames,
  listLeaderboard,
};

export default connect(mapStateToProps, mapDispatchToProps)(SessionsListPage);
